import Lenis from 'lenis';
document.addEventListener('DOMContentLoaded', function () {
  //define this as false by default
  var init_scroll = false; //defines our smooth pages

  var smooth_pages = ['page-template-page-glo']; //if the body has one of the smooth pages as a class

  for (var i = 0; i < smooth_pages.length; i++) {
    //if the body is one of the smooth pages
    if (document.body.classList.contains(smooth_pages[i])) {
      //set init_scroll to true
      init_scroll = true; //break out of the loop

      break;
    }
  } //if we're on a smooth page


  if (init_scroll) {
    //initialize Lenis
    var lenis = new Lenis({
      autoRaf: true
    });
  }
});